<div class="policy-container">
    <h2>{{'policy.data_title_1' | translate}}</h2>
    <p>{{'policy.data_title_1_content_1' | translate}}</p>
    <p>{{'policy.data_title_1_content_2' | translate}}</p>
</div>